export const SHOPIFY_REACT_ROUTER_LIBRARY_VERSION = '1.2.0';
